// CONCEPT: jQuery 4 removed a set of long-deprecated static helpers. Our own code no longer
// calls any of them, but one bundled plugin still does and cannot be fixed upstream, so the
// single symbol it needs is restored here rather than pinning jQuery back to 3.
// USE: nothing to call - importing it from main.js installs the shim. Import it BEFORE the
// plugins that need it.
//
// Only $.camelCase is restored, and only because owl.carousel 2.3.4 calls it in _trigger()
// when it builds a handler name (owl.carousel.js:1555). owl's last release was 2018 and the
// project is dormant, so there is no version of it that drops the call. Everything else the
// app loads was checked against jQuery 4's removals and is clean: jquery-ui-dist 1.13.3, the
// vendored aam-sky-banners, DataTables 3, Bootstrap 5, and our own source.
//
// Deliberately not a general jquery-migrate: restoring only what is actually called keeps the
// list honest, so when owl is replaced this file goes away rather than quietly covering for
// the next removed API someone reaches for.
//
// The patch has to go on window.jQuery, NOT on the imported `$`. The `jquery` specifier is
// aliased to src/js/jquery-global.js, which exports a Proxy with only apply and get traps -
// an assignment through it would land on that Proxy's dummy target, and owl (whose own
// `import $ from 'jquery'` resolves to the same Proxy) would still read undefined.
const jq = typeof window !== 'undefined' ? window.jQuery : undefined;

if (jq && typeof jq.camelCase !== 'function') {
    // jQuery 3.7.1's implementation verbatim: -ms- keeps its leading dash, then each
    // -x becomes X. Matching it exactly matters because owl feeds it event names.
    const rmsPrefix = /^-ms-/;
    const rdashAlpha = /-([a-z])/g;

    jq.camelCase = function (string) {
        return String(string)
            .replace(rmsPrefix, 'ms-')
            .replace(rdashAlpha, function (_all, letter) {
                return letter.toUpperCase();
            });
    };
}
